import axios from 'axios';
import _get from 'lodash/get';

function prepareGetParams(data) {
    if (!Object.keys(data).length) {
        return '';
    }

    return `?${Object.keys(data).map(k => k + '=' + encodeURIComponent(typeof data[k] === 'string' ? data[k] : JSON.stringify(data[k]))).join('&')}`;
}

const api = {
    call(url, data = {}, type = 'get', config = {}) {
        const apiUrl = '/api/' + 'v1/' + url;
        const axiosConf = {
            url: type === 'get' ? `${apiUrl}${prepareGetParams(data)}` : apiUrl,
            method: type,
            ...config,
        };

        if (type !== 'get') {
            axiosConf.data = data;
        }

        return axios(axiosConf)
            .then(result => _get(result, 'data', result))
            .catch(error => _get(error, 'response.data', error));
    },

    callV2(url, data = {}, type = 'get', config = {}) {
        const apiUrl = `/api/v2/${url}`;
        const axiosConf = {
            url: type === 'get' ? `${apiUrl}${prepareGetParams(data)}` : apiUrl,
            method: type,
            ...config,
        };

        if (type !== 'get') {
            axiosConf.data = data;
        }

        return axios(axiosConf)
            .then(result => _get(result, 'data', result))
            .catch(error => _get(error, 'response.data', error));
    },
};

export default api;
export { prepareGetParams };



// WEBPACK FOOTER //
// ./app/services/base.js